module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-conflicts"
  }, [_c('span', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.$t('conflict.message')))]), _vm._v(" "), _c('ul', _vm._l((_vm.conflicts), function(conflict) {
    return _c('li', [_vm._v("\n            " + _vm._s(_vm.$t('conflict.' + conflict)) + "\n            "), (_vm.isResolvable(conflict)) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.resolve(conflict)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.button.okay')))]) : _vm._e(), _vm._v(" "), (conflict == 'AVAILABILITY') ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.resolve(conflict)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('page.roster.undroppable.confirm')))]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef1319c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Conflicts.vue
// module id = 589
// module chunks = 225